var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBssiDs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "47px",
    height: "43px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "47px",
    height: "43px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAArCAQAAABCvxkxAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfoBBMREiIxn5WOAAABt0lEQVRIx+2WPWvCQBjHn5TH2QwZusUhuxmyJ0N2O2SPQz6AQ3YFca7gB4ggmVMozgascwRxjiBOHQ4rTgrXIaKJebcUWsjdkJd77ve/5+UuYSjkNgRYinvWlYNHdi8u+U1jA+f8qUCzOnpSZ6TMk4bYgzIfmr5AMYuQOkC4odnYZqsDBSquxka6RAq612cP+eibJ2kSCQFxtGS0vAh6c53shSfFJWLr7oyir/idbjsa4SheJyNFX7AM3a4fo7a9/r3AHVxcRdc7UzNTh5bB78Iv2pMMvKOVQCdK1I9eRnDQMoKb7iCGRoqEc1WKoTBdvW5NL3ApO7U4U/mdo4UBhBsb7Uk43Y1te/KmES4879WMw2netvKFKDhajr1+WIIUKswQfGjmV3zU08J4Ai/v+Xm9lGN5vAfhktNty/CFIK2e9GrKi9tYc03K4ykQLtifup1wcOFMDSRa00iKy6SWcPLCSj+wsDvQ7ey9wRQ473/Q8CHbIh8SAAB4Kk53FebEnJhTmdWXwD/SKnyFr/AVvsJX+L+PR0BXKWa6FINrUXuA2hk+n4v96j3SOfLPY187Kx+/Ba9/fQNzygVDf4XLjQAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBssiDs);
export default __webpack_public_path__ + "static/media/BSSIDs.e9eac1c9f3bca84badb5303f802e1a41.svg";
export { ForwardRef as ReactComponent };